/**
 * windowClass for NgbModals that become a full-screen sheet below 576px (opened with `fullscreen: 'sm'`):
 * pinned header and footer, scrolling body, one field per row and touch-sized controls. Styles live in
 * assets/styles/_modals.scss.
 */
export const RMS_SHEET_MODAL_CLASS = 'rms-sheet-modal';
